import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type CheckCircleInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function CheckCircleInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: CheckCircleInactiveIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
      className={className}
      fill="none"
    >
      <Path
        d="M6.9 12.087l2.664 2.663a1.009 1.009 0 001.433 0l5.367-5.367"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M12 21.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default CheckCircleInactiveIcon;
